import type { CSSProperties, UIEvent } from 'react';
import { useCallback, useState } from 'react';
import { IconChevronLeft, IconCross } from '../icon';
import type { IBackLinkProps, IBackLinkState } from './BackLink.interface';
import { classNameForElement, StyleElem, styleForElement } from './BackLink.style';

function BackLink(props: IBackLinkProps): JSX.Element {
    const [state, setState] = useState<IBackLinkState>({ isHighlighted: false });

    const IconView = props.icon === 'cross' ? IconCross : IconChevronLeft;

    const onHighlight = useCallback(() => {
        setState(stateOld => ({
            ...stateOld,
            isHighlighted: true,
        }));
    }, [setState]);

    const onRestore = useCallback(() => {
        setState(stateOld => ({
            ...stateOld,
            isHighlighted: false,
        }));
    }, [setState]);

    const onClick = (event: UIEvent) => {
        event.preventDefault();
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        props.onClick?.(props);
        return false;
    };

    const style = (elem: StyleElem, overrides: CSSProperties = {}) =>
        styleForElement(elem, props, state, overrides);
    const className = (elem: StyleElem) => classNameForElement(elem, props);

    return (
        <a
            title={props.text ?? 'back'}
            className={`${props.className ?? ''} ${className(StyleElem.Container)}`}
            style={style(StyleElem.Container)}
            onTouchStart={onHighlight}
            onMouseDown={onHighlight}
            onTouchEnd={onRestore}
            onTouchCancel={onRestore}
            onMouseUp={onRestore}
            onMouseLeave={onRestore}
            onClick={onClick}
            /* eslint-disable-next-line no-script-url */
            href={props.href ?? 'javascript:history.back(1);'}
        >
            <div className={className(StyleElem.Div)} style={style(StyleElem.Div)}>
                <IconView className={className(StyleElem.SVG)} style={style(StyleElem.SVG)} />
            </div>
        </a>
    );
}

export default BackLink;
